import React from 'react';
import classNames from 'classnames';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ModalHeader(_ref) {
  var className = _ref.className,
    children = _ref.children,
    _ref$closeButton = _ref.closeButton,
    closeButton = _ref$closeButton === void 0 ? true : _ref$closeButton,
    style = _ref.style,
    toggle = _ref.toggle,
    dataTestId = _ref['data-testid'];
  return /*#__PURE__*/_jsxs("div", {
    className: classNames('modal-header', className),
    style: style,
    children: [/*#__PURE__*/_jsx("h5", {
      className: "modal-title",
      children: children
    }), closeButton && /*#__PURE__*/_jsx("button", {
      type: "button",
      className: "close",
      "data-dismiss": "modal",
      "aria-label": "Close",
      onClick: toggle,
      children: /*#__PURE__*/_jsx("span", {
        "aria-hidden": "true",
        children: "\xD7"
      })
    })]
  });
}
export default ModalHeader;
//# sourceMappingURL=ModalHeader.js.map